import React from 'react';
import { Field } from 'react-final-form';

import FormatError from './FormatError/FormatError';

interface Props {
  name: string;
  className?: string;
  immediate?: boolean;
}

const Error: React.FC<Props> = ({ name, className, immediate }) => (
  <Field
    name={name}
    subscription={{ touched: true, error: true }}
    render={({ meta: { touched, error } }) =>
      (touched || immediate) && error ? (
        <FormatError errorMessage={error.message} className={className} />
      ) : null
    }
  />
);

export default Error;
